module.exports = __webpack_public_path__ + "img/user.98f6f3e6.svg";